import React, { useEffect, useRef, useState } from "react";
import config from "../../config/app.json";
import { GridAreaComponent } from "./GridAreaComponent";
import { DroppableAreaContainer } from "./styledComponent";
import { getImageSource, getGridDropAreaId, GRID_CLASSES } from "../../helpers/frameHelper";
import { getImageThumbnailURL } from "../../helpers/URLHelper";

const appUrl = config['APPICONS'][config['APPICONS']['current']];

export function DroppableAreaComponent(props) {
    const {
        droppableCellData,
        gridItemData,
        gridCellWidth,
        gridCellHeight,
        cellId,
        itemId,
        idPrefix,
        onLoadData,
    } = props;

    const { browserName, zoomFactor, Id, } = props;

    const imageRef = React.useRef();
    const imageContainerRef = useRef();
    const droppableAreaGridRef = useRef();

    const [showGridArea, setShowGridArea] = useState(false);
    const [showImage, setShowImage] = useState(false);

    const [cellStyle, setCellStyle] = useState(
        getCellStyle(gridCellWidth, gridCellHeight)
    );

    useEffect(() => {
        setCellStyle(getCellStyle(gridCellWidth, gridCellHeight));
    }, [gridCellWidth, gridCellHeight]);

    useEffect(() => {
        if (
            droppableCellData.getIn(["imgDetails", "color"]) !== undefined
            && droppableCellData.getIn(["imgDetails", "color"]) !== ""
            && droppableCellData.getIn(["imgDetails", "src"]) === ""
        ) {
            setShowGridArea(false);
        } else { // color picker undo
            setShowGridArea(true);
        }
    }, [droppableCellData]);

    function getCellStyle(itemWidth, itemHeight) {
        return {
            width: itemWidth,
            height: itemHeight,
            gridArea: cellId,
        };
    }

    useEffect(() => {
        if (
            droppableCellData.get("color") ||
            droppableCellData.get("imgDetails")
        ) {
            setShowGridArea(true);
        } else {
            setShowGridArea(false);
        }

        if (droppableCellData.get("imgDetails") !== undefined) {
            setShowImage(true);
        } else {
            setShowImage(false);
        }
    }, [droppableCellData]);

    function getSource() {
        let imageDetails = droppableCellData.getIn(["imgDetails"]);
        if (imageDetails) {
            let defaultImageSrc = `${appUrl}${imageDetails.getIn(["defaultImageDetails", "src"])}`

            let { src } = getImageSource(imageDetails);
            if (!imageDetails.get("src") && !imageDetails.get('stickerify') && !imageDetails.get('bgremoval')) {
                return defaultImageSrc;
            }

            return src;
        }
    }

    function getFlipPosition(value) {
        let flip =
            value === 1
                ? " scaleX(-1)"
                : value === 2
                    ? " scaleY(-1)"
                    : value === 3
                        ? " scaleX(-1) scaleY(-1)"
                        : "";
        return flip;
    }

    function getStyles() {
        let styles = {};
        // let flipPosition =
        //     imageEffects && imageEffects.size > 0 &&
        //         imageEffects.get("effectName") === "doubleExposure" &&
        //         selectedItemId === itemId && selectedClipId === cellId
        //         ? ""
        //         : droppableCellData.getIn(["imgDetails", "flipPosition"]);
        let flipPosition = droppableCellData.getIn(["imgDetails", "flipPosition"]);
        flipPosition = flipPosition ? flipPosition : 0

        if (droppableCellData.get("imgDetails")) {
            let widthScale = droppableCellData.getIn([
                "imgDetails",
                "original",
                "width",
            ]);
            let heightScale = droppableCellData.getIn([
                "imgDetails",
                "original",
                "height",
            ]);
            let xScale = droppableCellData.getIn([
                "imgDetails",
                "original",
                "x",
            ]);
            let yScale = droppableCellData.getIn([
                "imgDetails",
                "original",
                "y",
            ]);

            styles = {
                width: (gridCellWidth * zoomFactor) * widthScale,
                height: (gridCellHeight * zoomFactor) * heightScale,
                transform: `translate(${(gridCellWidth * zoomFactor) * xScale}px, ${(gridCellHeight * zoomFactor) * yScale
                    }px) ${getFlipPosition(flipPosition)}`,
            };
        } else {
            styles = {};
        }
        if (droppableCellData.get("color")) {
            let backgroundStyles = {
                background: droppableCellData.get("color"),
            };
            styles = Object.assign(styles, backgroundStyles);
        }

        return styles;
    }

    return (
        <DroppableAreaContainer
            style={{
                width: `${cellStyle.width * zoomFactor}px`,
                height: `${cellStyle.height * zoomFactor}px`,
                gridArea: cellStyle.gridArea,
                pointerEvents: "none",
                borderRadius: gridItemData.getIn(["gridData", "borderRadius"]) ? `${gridItemData.getIn(["gridData", "borderRadius"]) * zoomFactor}px` : 0
            }}
            className={`droppable_area_container cell-${cellId} ${GRID_CLASSES["DROP_AREA"]}`}
            id={getGridDropAreaId(Id, cellId, idPrefix)}
            ref={droppableAreaGridRef}
        >
            <GridAreaComponent
                itemId={itemId}
                cellId={cellId}
                cellStyle={cellStyle}
                imageRef={imageRef}
                imageContainerRef={imageContainerRef}
                showGridArea={showGridArea}
                showImage={showImage}
                filterData={droppableCellData.getIn(["imgDetails", "filter"])}
                droppableCellData={droppableCellData}
                flipPosition={gridItemData.get("flipPosition")}
                src={getSource()}
                thumb={getImageThumbnailURL(droppableCellData.getIn(["imgDetails", "type"]), droppableCellData.getIn(["imgDetails", "subType"]), droppableCellData.getIn(["imgDetails", "thumb"]) || droppableCellData.getIn(["imgDetails", "thumbnail"]))}
                containerStyles={getStyles()}
                browserName={browserName}
                idPrefix={idPrefix}
                onLoadData={onLoadData}
            />
        </DroppableAreaContainer>
    );
}


// WEBPACK FOOTER //
// ./src/components/Grid/DroppableAreaComponent.js